import Profile from "../../Components/Profile/Profile";
import ProfileNavbar from "../../Components/ProfileNavbar/ProfileNavbar";

export default function ProfilePage() {

  return (
    <>
        <ProfileNavbar/>
        <Profile/>
    </>
  );
}
